import { Injectable } from '@angular/core';
import { StatsDataDetails } from '../due-diligence/model/StatsDataDetails';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatsDataService {

  private statsDataDetails = {
    noAcquisitions: '',
    rateCompliance: '',
    rateSubmission: ''
  } as StatsDataDetails;

  public statsDataDetailsSub = new Subject<StatsDataDetails>();

  constructor() { 
    // console.log("StatsDataService constructor");
  }

  public setStatsDataDetails(statsDataDetails: StatsDataDetails) {
    this.statsDataDetails = statsDataDetails;
  }

  public setNoAcquisitions(noAcquisitions: string) {
    this.statsDataDetails.noAcquisitions = noAcquisitions;
  }

  public setRateCompliance(rateCompliance: string) {
    this.statsDataDetails.rateCompliance = rateCompliance;
  }

  public setRateSubmission(rateSubmission: string) {
    this.statsDataDetails.rateSubmission = rateSubmission;
  }

  public notifySubscribers() {
    this.statsDataDetailsSub.next(this.statsDataDetails);
  }
}
